@for (label of labels; track label) {
  <sh-text color="secondary" class="label">{{ label }}</sh-text>
}
